import algoliasearch from "algoliasearch";

const algoliaSearchClient = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID as string,
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY as string
);

const algoliaEventIndex = algoliaSearchClient.initIndex("events");
const algoliaNewsIndex = algoliaSearchClient.initIndex("news");
const algoliaSpeakersIndex = algoliaSearchClient.initIndex("speakers");
const algoliaVideoIndex = algoliaSearchClient.initIndex("videos");

export default algoliaSearchClient;

export { algoliaEventIndex, algoliaNewsIndex, algoliaSpeakersIndex, algoliaVideoIndex };